import React from 'react';
import Isvg from 'react-inlinesvg'
import './IconList.scss';

const renderIcons = icons => icons.map(icon => <li><Icon {...icon}/></li> )

const Icon = ({ src, url }) => (
    <a href={url} target="_blank">
        <Isvg src={src} />
    </a>
)

const IconList = ({ icons }) => (
    <ul className="icon-list">
        { renderIcons(icons) }
    </ul>
)

export default IconList;


// WEBPACK FOOTER //
// ./src/components/Footer/IconList.js